import React from 'react';
import { relationshipContactSearch } from '@/utils/typesense/clients/relationshipContactSearch';
import { RelationshipSelect } from '@/components/selects/RelationshipSelect';

const contactLabels = {
	placeholder: 'Search for contact',
	loadingText: 'Loading contacts...',
	emptyText: 'No contacts found',
};

const mapContactOption = {
	fromHit: (hit) => ({
		id: hit.id,
		fullName: hit.fullName,
		email: hit.email,
		mobile: hit.mobile,
	}),
	label: (option) => option.fullName,
	optionText: (option) =>
		option.email ? `${option.fullName} (${option.email})` : option.fullName,
	selectedLabel: (value) => (value ? value.fullName : ''),
};

export const RelationshipContactSelect = ({
	value,
	onChange,
	disabled = false,
	error = false,
	helperText,
	required = false,
}) => (
	<RelationshipSelect
		searchClient={relationshipContactSearch}
		indexName='relationshipContacts'
		labels={contactLabels}
		mapOption={mapContactOption}
		extraFilter='relationshipStatus:!=archived'
		value={value}
		disabled={disabled}
		error={error}
		helperText={helperText}
		required={required}
		onSelect={(option) => onChange?.(option)}
		onClear={() => onChange?.(null)}
	/>
);
